import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { faBan, faInfoCircle, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors, spacing } from '../../styles/_var'
import Text, { BoldText } from '../../components/Text'
import AllContestants from './AllContestants'
import { ContestantWithBio, ICategory } from '../../utils/interfaces'
import { TextWithIconHorizontal } from '../../components/StyledComponents'
import CompetitionCategoryDropdown from '../../components/CompetitionCategoryDropdown'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'


interface ICompetitionContestants {
  contestants: ContestantWithBio[],
  loading?: boolean,
  onVote: (contestantUsername: string) => () => void,
  votingClosed?: boolean,
  userIsLoggedIn?: boolean,
  seasonConcluded?: boolean,
  showVoteCount?: boolean
  upcomingVotingRoundStarts?: string
  selectedCategory?: ICategory
  categories: ICategory[]
  onSelectCategory: (category: ICategory) => void
}

const CompetitionPageContestants: FunctionComponent<ICompetitionContestants> = ({
  contestants,
  loading,
  onVote,
  votingClosed,
  userIsLoggedIn,
  seasonConcluded,
  showVoteCount,
  upcomingVotingRoundStarts,
  categories,
  selectedCategory,
  onSelectCategory,
}) => {
  return (
    loading ? (
      <TextWithIcon>
        <FontAwesomeIcon icon={faSpinner} spin size="2x"/> 
        <Text variant="medium">Fetching Contestants.</Text>
      </TextWithIcon>
    ) : (
      <>
        <CompetitionCategoryDropdown 
          selectedCategory={selectedCategory}
          categories={categories}
          onSelectCategory={onSelectCategory}
        />
        <Box mt={4}>
          {(votingClosed || seasonConcluded) && (!upcomingVotingRoundStarts) && (
            <TextWithIconHorizontal>
              <FontAwesomeIcon
                icon={seasonConcluded ? faInfoCircle : faBan}
                size="2x"
                color={colors.red}
              />
              <Text 
                color={colors.red}
                variant="medium"
                role="alert"
                aria-label="There are no open voting rounds"
              >
                {seasonConcluded ? 'This Season is over!' : 'There are no open voting rounds'}
              </Text>
            </TextWithIconHorizontal>
          )}
          {!votingClosed && !userIsLoggedIn && (
            <Box mb={2}>
              <Alert variant="standard" severity="warning" icon={false} sx={{display: "block"}}>
                <Text 
                  weight="semi-bold"
                  center
                  variant="medium"
                  role="alert"
                  aria-label="Please login">
                  Hi there! You need to login first to vote.
                </Text>
              </Alert>
            </Box>
          )}
          <AllContestants
            votingClosed={votingClosed}
            onVote={onVote}
            contestants={contestants}
            variant="default"
            showVoteCount={showVoteCount}
          />
          {upcomingVotingRoundStarts && (
            <Box mt={2}>
              <Alert variant="standard" severity="info" icon={false} sx={{display: "block"}}>
                <BoldText variant="regular" center>
                  Voting Starts {upcomingVotingRoundStarts}
                </BoldText>
              </Alert>
            </Box>
          )}
        </Box>
      </>
    )
  )
}

export default CompetitionPageContestants

const TextWithIcon = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${spacing.sm};
  color: ${colors.purple};
`